/* Sushicare — small runtime: countdowns + dismissible contest card */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick(el, target) {
    var diff = target - Date.now();
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
    var q = function (sel) { return el.querySelector(sel); };
    if (q('[data-d]')) q('[data-d]').textContent = d;
    if (q('[data-h]')) q('[data-h]').textContent = pad(h);
    if (q('[data-m]')) q('[data-m]').textContent = pad(m);
    if (q('[data-s]')) q('[data-s]').textContent = pad(s);
  }
  function startCountdown(el) {
    var t = Date.parse(el.dataset.target);
    if (isNaN(t)) return;
    tick(el, t);
    var every = el.querySelector('[data-s]') ? 1000 : 30000;
    setInterval(function () { tick(el, t); }, every);
  }

  class ScContestCard extends HTMLElement {
    connectedCallback() {
      var key = this.dataset.key || 'sc-contest-dismissed';
      var dismissed = false;
      try { dismissed = sessionStorage.getItem(key) === '1'; } catch (e) {}
      if (dismissed || document.documentElement.classList.contains('sc-contest')) return;
      this.hidden = false;
      startCountdown(this);
      var self = this;
      var btn = this.querySelector('[data-dismiss]');
      if (btn) btn.addEventListener('click', function () {
        self.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  }
  if (!customElements.get('sc-contest-card')) customElements.define('sc-contest-card', ScContestCard);

  class ScCountdown extends HTMLElement {
    connectedCallback() { startCountdown(this); }
  }
  if (!customElements.get('sc-countdown')) customElements.define('sc-countdown', ScCountdown);
})();
